export default __webpack_public_path__ + "static/media/SpentAll.c7edb7e9.png";